<template>
<v-main class="pa-3 pb-4">
    <v-card class="mx-2" v-if="!isPerfil">

        <v-tabs centered background-color="secondary accent-4" dark>
            <v-tab>
                <v-icon left>
                    mdi-account
                </v-icon>
                Usuários
            </v-tab>
            <v-tab>
                <v-icon left>
                    label
                </v-icon>
                Vouchers
            </v-tab>
            <v-tab>

                <v-icon left>
                  tab
                </v-icon>
                Pacotes Laboratoriais
            </v-tab>
            <v-tab>

             <v-icon left>
               folder
             </v-icon>
             Pacotes Ocupacionais
         </v-tab>
            <v-tab-item>
                <v-card flat class="ma-2" v-if="!isCadastro">
                    <v-card-title>

                        <v-spacer></v-spacer>
                        <v-text-field color="secondary accent-4" v-model="searchAtivo" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
                    </v-card-title>
                    <!-- {{ listaUsuarios }} -->
                    <v-data-table no-data-text="Nenhum item disponível" :headers="headers" :items="listaUsuarios" :search="searchAtivo">

                        <template v-slot:item.status="{ item }">
                            <div  :class="item.status == 'ativo'? 'mr-4 green--text' : 'mr-4 red--text' "> {{item.status}} </div>

                        </template>

                        <template v-slot:item.actions="{ item }">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" icon small v-on="on" @click="$router.push({name: 'perfilUsuario', params: {_id: item._id}}) ">
                                        <v-icon medium color="success">person </v-icon>
                                    </v-btn>
                                </template>
                                <span>Perfil</span>
                            </v-tooltip>
                            <vincularVoucher v-bind:usuario="item"/>
                            <v-tooltip bottom>
                                <span>Vincular Voucher</span>
                            </v-tooltip>
                        </template>

                    </v-data-table>
                </v-card>
                <v-layout style="height: 90px; position: relative" right bottom>
                    <v-btn v-show="!isCadastro" id="mybutton" top-of="footer" right fab dark color="teal darken-4" @click="$router.push({ name: 'cadastrarUsuario', params: { cadastro: true, _id: null} })">
                        <v-icon dark>add</v-icon>
                    </v-btn>
                </v-layout>
            </v-tab-item>
            <v-tab-item>
                <Voucher />
            </v-tab-item>
            <v-tab-item>
                <PacoteExames :sadt="true" />
              </v-tab-item>
              <v-tab-item>
                <PacoteExames :sadt="false" />
              </v-tab-item>
        </v-tabs>

    </v-card>

    <v-card class="mx-2" v-if="isPerfil">
      <PerfilUsuario :id="perfilSelecionado._id"/>
    </v-card>
</v-main>
</template>

<script>
import PerfilUsuario from './PerfilUsuario.vue'
import usuarioService from '../../../services/usuario.service'
import vincularVoucher from './VincularVoucher.vue'
import PacoteExames from './PacoteExames.vue'
import Voucher from './Voucher.vue'

export default {
  components: {
    PacoteExames,
    Voucher,
    vincularVoucher,
    PerfilUsuario
  },
  data () {
    return {
      page: 1,
      tipo: 2,
      tab: 1,
      listaFuncionariosAtivos: [],
      listaFuncionariosDesativos: [],
      listaFuncionarios: [],
      user: null,
      isCadastro: false,
      isPerfil: false,
      searchAtivo: '',
      valid: false,
      listaUsuarios: [],
      value: '',
      perfilSelecionado: '',
      headers: [{
        text: 'Nome do Usuário',
        align: 'center',
        sortable: true,
        value: 'nomeCompleto'
      },
      {
        text: 'Status',
        align: 'center',
        value: 'status',
        sortable: true
      },
      {
        text: 'Ações',
        align: 'center',
        value: 'actions',
        sortable: false
      }
      ]
    }
  },
  methods: {
    listarUsuarios () {
      usuarioService.listarUsuarios().then(r => {
        if (r.status == 200) {
          console.log('USUARIOS: ', r.data)
          this.listaUsuarios = r.data
        }
      })
    }
  },
  mounted () {
    this.listarUsuarios()
  }
}
</script>

<style scoped>
.md-card {
    width: 320px;
    margin: 4px;
    display: inline-block;
    vertical-align: top;
}

.feedback {
    background-color: #31b0d5;
    color: white;
    padding: 10px 20px;
    border-radius: 4px;
    border-color: #46b8da;
}

#mybutton {
    position: fixed;
    bottom: 20px;
    right: 10px;
}

#mybutton2 {
    position: fixed;
    bottom: 30px;
    right: 20px;
}

.rounded-card {
    border-radius: 35px;
}
</style>
